import React from "react";
import { Route, Redirect } from "react-router-dom";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import Loader from "../components/loader";

// Any signed-in evoJets (internal) user. Outside-organization accounts
// (partner/operator logins) are redirected home. Used for /accounting, where
// the Amex tab is open to all internal staff but the page must never render
// for an outside organization. The server enforces the same rule.
const InternalUserRoute = ({ component, ...args }) => {
  const { user } = useAuth0();
  const outsideOrg = !!user?.["https://new.evojets.com/outsideOrganization"];

  if (user && outsideOrg) {
    return <Redirect to="/" />;
  }

  return (
    <Route
      component={withAuthenticationRequired(component, {
        onRedirecting: () => <Loader />,
      })}
      {...args}
    />
  );
};

export default InternalUserRoute;
